import { render, staticRenderFns } from "./review-rating.vue?vue&type=template&id=1f7a707e"
import script from "./review-rating.vue?vue&type=script&lang=js"
export * from "./review-rating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports